<template>
  <el-container class="layout desktop">

    <template v-if="isSideMenu()">
      <side-menu
        mode="inline"
        :menus="menus"
        :theme="navTheme"
        :collapsed="collapsed"
        :collapsible="true"></side-menu>
    </template>

    <el-container
      :class="[layoutMode, `content-width-${contentWidth}`]"
      :style="{ paddingLeft: contentPaddingLeft, minHeight: '100vh' }"
    >
      <!-- layout header -->
      <global-header
        :mode="layoutMode"
        :menus="menus"
        :theme="navTheme"
        :collapsed="collapsed"
        @toggle="toggle"
      />

      <!-- layout content -->
      <el-main
        :style="{
          margin: $store.getters.multiTab ? '24px 24px 0' : '24px 24px 0',
          height: '100%',
          paddingTop: fixedHeader ? '64px' : '0'
        }"
      >
        <slot></slot>
      </el-main>

      <!-- layout footer -->
      <el-footer height="122px" style="padding: 0">
        <global-footer />
      </el-footer>

      <z-back-top />
    </el-container>
  </el-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'

import SideMenu from '@/components/menu/side-menu'
import GlobalHeader from '@/components/page/global-header'
import GlobalFooter from '@/components/page/global-footer'
import { triggerWindowResizeEvent } from '@/utils/util'
import { mixin } from '@/utils/mixin.js'

import { asyncRouterMap } from '@/router/router.config'

export default {
  name: 'GlobalLayout',
  components: {
    SideMenu,
    GlobalHeader,
    GlobalFooter
  },
  mixins: [mixin],
  data () {
    return {
      collapsed: false,
      menus: asyncRouterMap
    }
  },
  computed: {
    ...mapState({
      // 主路由
      // mainMenu: state => state.permission.addRouters
      // FIXME:
      mainMenu: state => state.permission.routers
    }),
    contentPaddingLeft () {
      if (!this.fixSidebar) {
        return '0'
      }
      if (this.sidebarOpened) {
        return '256px'
      }
      return '80px'
    }
  },
  watch: {
    sidebarOpened (val) {
      console.log('sidebarOpened', val)
      this.collapsed = !val
    }
  },
  created () {
    // this.menus = this.mainMenu.find((item) => item.path === '/').children
    this.menus = asyncRouterMap.find((item) => item.path === '/').children
    this.collapsed = !this.sidebarOpened
  },
  methods: {
    ...mapActions(['setSidebar']),
    toggle () {
      this.collapsed = !this.collapsed
      this.setSidebar(!this.collapsed)
      triggerWindowResizeEvent()
    },
    paddingCalc () {
      let left = ''
      if (this.sidebarOpened) {
        left = '256px'
      } else {
        left = (this.fixSidebar && '80px') || '0'
      }
      console.log('left', left)
      return left
    },
    menuSelect () {
    }
  }
}
</script>

<style lang="scss">
  body {
    // 打开滚动条固定显示
    overflow-y: scroll;

    &.colorWeak {
      filter: invert(80%);
    }
  }
  section{
    width: 100%;
    min-width: 800px !important;
  }
  .el-table__fixed{
    pointer-events: none;
  }
  .layout.el-container {
    // overflow-x: auto;

    .trigger {
      font-size: 20px;
      line-height: 64px;
      padding: 0 24px;
      cursor: pointer;
      transition: color .3s;
      &:hover {
        background: rgba(0, 0, 0, 0.025);
      }
    }

    .topmenu {
      .ant-header-fixedHeader {
        position: fixed;
        top: 0;
        right: 0;
        z-index: 9;
        width: 100%;
        transition: width .2s;

        &.ant-header-side-opened {
          width: 100%;
        }

        &.ant-header-side-closed {
          width: 100%;
        }
      }
      /* 必须为 topmenu  才能启用流式布局 */
      &.content-width-Fluid {
        .header-index-wide {
          max-width: unset;
          margin-left: 24px;
        }

        .page-header-index-wide {
          max-width: unset;
        }
      }

    }

    .sidemenu {
      .ant-header-fixedHeader {
        position: fixed;
        top: 0;
        right: 0;
        z-index: 9;
        width: 100%;
        transition: width .2s;

        &.ant-header-side-opened {
          width: calc(100% - 256px)
        }

        &.ant-header-side-closed {
          width: calc(100% - 64px)
        }
      }
    }

    .header {
      position: relative;
      padding: 0 12px 0 0;

      height: 60px;
      line-height: 60px;

      background: #fff;
      box-shadow: 0 1px 1px rgba(0, 21, 41, .08);
    }

    .header, .top-nav-header-index {

      .user-wrapper {
        float: right;
        height: 100%;

        .action {
          cursor: pointer;
          padding: 0 12px;
          display: inline-block;
          transition: all .3s;
          height: 100%;

          &:hover {
            background: rgba(0, 0, 0, 0.025);
          }

          .avatar {
            margin: 0 8px 0 0;
            width: 24px;

            color: #1890ff;
            background: hsla(0, 0%, 100%, .85);
            border-radius: 50%;
            vertical-align: middle;
          }

          .icon {
            font-size: 16px;
            padding: 4px;
          }
        }
      }

      &.dark {
        .user-wrapper {

          .action {
            color: rgba(255, 255, 255, 0.85);

            &:hover {
              background: rgba(255, 255, 255, 0.16);
            }
          }
        }
      }
    }

    .top-nav-header-index {
      box-shadow: 0 1px 4px rgba(0,21,41,.08);
      position: relative;
      transition: background .3s,width .2s;

      .header-index-wide {
        max-width: 1200px;
        margin: auto;
        padding-left: 0;
        display: flex;
        height: 64px;
        line-height: 64px;

        .ant-menu.ant-menu-horizontal {
          border: none;
          height: 64px;
          line-height: 64px;
        }

        .header-index-left {
          flex: 1 1;
          display: flex;

          .logo.top-nav-header {
            width: 165px;
            height: 60px;
            position: relative;
            line-height: 60px;
            transition: all .3s;
            overflow: hidden;

            img {
              display: inline-block;
              vertical-align: middle;
              height: 18px;
            }

            h1 {
              color: red;
              display: inline-block;
              vertical-align: top;
              font-size: 16px;
              margin: 0 0 0 12px;
              font-weight: 400;
            }
          }
        }

        .header-index-right {
          float: right;
          height: 64px;
          overflow: hidden;
        }
      }

      &.light {
        background-color: #fff;

        .header-index-wide {
          .header-index-left {
            .logo {
              h1 {
                color: #002140;
              }
            }
          }
        }
      }

      &.dark {
        background-color: #001529;
      }
    }

    // 内容区
    .layout-content {
      margin: 24px 24px 0px;
      height: 100%;
      height: 64px;
      padding: 0 12px 0 0;
    }

    .el-footer {
      background-color: #f0f2f5;
    }
  }

  .topmenu {
    .page-header-index-wide {
      max-width: 1200px;
      margin: 0 auto;
    }
  }

  // drawer-sider 自定义
  .ant-drawer.drawer-sider {
    .sider {
      box-shadow: none;
    }

    &.dark {
      .ant-drawer-content {
        background-color: rgb(0, 21, 41);
      }
    }
    &.light {
      box-shadow: none;
      .ant-drawer-content {
        background-color: #fff;
      }
    }

    .ant-drawer-body {
      padding: 0
    }
  }

  // 菜单样式
  .sider {
    position: relative;
    z-index: 10;

    .ant-layout-sider-children:hover {
      overflow-y: auto;
    }

    &.ant-fixed-sidemenu {
      position: fixed;
      height: 100%;
    }

    .logo {
      height: 60px;
      position: relative;
      line-height: 60px;
      padding-left: 24px;
      -webkit-transition: all .3s;
      transition: all .3s;
      background: white;
      overflow: hidden;
      box-shadow: 0 1px 1px rgba(0, 21, 41, 0.08);

      img, h1 {
        display: inline-block;
        vertical-align: middle;
      }

      img {
        width: 64px;
      }

      h1 {
        color: rgba(51,51,51,0.94);
        font-size: 16px;
        margin: 0 0 0 12px;
        font-family: "Chinese Quote", -apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "Helvetica Neue", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
        font-weight: 600;
      }
    }

    &.light {
      background-color: #fff;
      box-shadow: none;

      .logo {
        background: #fff;
        /*box-shadow: 1px 1px 0px 0px #e8e8e8;*/

        h1 {
          color: rgba(51,51,51,0.94);
        }
      }

      .ant-menu-light {
        border-right-color: transparent;
      }
    }
  }
  .sider.z-sider--collapsed {
    .logo {
      padding-left: 0;
    }
  }

  // 外置的样式控制
  .user-dropdown-menu {
    span {
      user-select: none;
    }
  }
  .user-dropdown-menu-wrapper.ant-dropdown-menu {
    padding: 4px 0;

    .ant-dropdown-menu-item {
      width: 160px;
    }

    .ant-dropdown-menu-item > .anticon:first-child,
    .ant-dropdown-menu-item > a > .anticon:first-child,
    .ant-dropdown-menu-submenu-title > .anticon:first-child
    .ant-dropdown-menu-submenu-title > a > .anticon:first-child {
      min-width: 12px;
      margin-right: 8px;
    }

  }

  // 数据列表 样式
  .table-alert {
    margin-bottom: 16px;
  }

  .content {

    .table-operator {
      margin-bottom: 18px;

      button {
        margin-right: 8px;
      }
    }
  }
</style>
